export enum SettingsTab {
  Packs = "packs",
  Themes = "themes",
  Order = "order",
  Misc = "misc"
}
